import {create} from "zustand";
import {derivedRemoteStore} from "./DerivedStore";
import {Employee, EmployeeRef, INeighbourhood, Neighbourhood} from "./Model";
import {getOrSet} from "../util/MapUtil";
import {useNeighbourhoodStore} from "./NeighbourhoodStore";
import {emptyArray} from "../util/FunctionUtil";

export class EmployeeNeighbourhood<Hood extends INeighbourhood = INeighbourhood> {
    constructor(private readonly employeeNeighbourhoods: Map<Employee['id'], Hood[]>) {
    }

    static from(neighbourhoods: Neighbourhood[]): EmployeeNeighbourhood<Neighbourhood> {
        const employeeNeighbourhoods = new Map<Employee['id'], Neighbourhood[]>();
        neighbourhoods.forEach(neighbourhood => {
            neighbourhood.employees.forEach(employee => {
                getOrSet(employeeNeighbourhoods, employee.id, emptyArray).push(neighbourhood);
            })
        })
        return new EmployeeNeighbourhood(employeeNeighbourhoods);
    }

    has(employee: EmployeeRef): boolean {
        const neighbourhoods = this.employeeNeighbourhoods.get(employee.id);
        return !!neighbourhoods && neighbourhoods.length > 0;
    }

    get(employee: EmployeeRef): Hood[] {
        return this.getById(employee.id);
    }

    getById(employeeId: number): Hood[] {
        return this.employeeNeighbourhoods.get(employeeId) || [];
    }

    getFirst(employee: EmployeeRef): Hood | undefined {
        const neighbourhoods = this.employeeNeighbourhoods.get(employee.id);
        return neighbourhoods && neighbourhoods.length > 0 ? neighbourhoods[0] : undefined;
    }

    get length(): number {
        return this.employeeNeighbourhoods.size;
    }
}

export const useEmployeeNeighbourhoodStore = create(
    derivedRemoteStore(
        {neighbourhoods: useNeighbourhoodStore},
        ({neighbourhoods}) => {
            return EmployeeNeighbourhood.from(neighbourhoods);
        },
    )
);